import api from './axios';
import { API_ENDPOINTS } from '../constants';
import { logError } from '../common/utils/logger';

/**
 * Fetches journey masters from a unified backend endpoint.
 *
 * @param {string} masterType - Master selector (e.g. bankdetails, statedetails, relationshipdetails)
 * @param {string} filter - Optional OData filter expression
 * @returns {Promise<Object>} API response with masterType, items and totalCount
 */
export const fetchJourneyMasters = async (masterType, filter) => {
  try {
    if (!masterType || !String(masterType).trim()) {
      throw new Error('masterType is required.');
    }

    const params = { masterType: String(masterType).trim() };
    if (filter && String(filter).trim()) {
      params.filter = String(filter).trim();
    }

    const response = await api.get(API_ENDPOINTS.JOURNEY_MASTERS, { params });
    return response?.data ?? null;
  } catch (error) {
    logError('[fetchJourneyMasters] Failed to fetch journey masters', error);
    throw error;
  }
};
